<template>
    <div class="form-data">
        <div v-for="(item, index) in form" :key="'achievements_' + index">
            <div class="heading-24 form__title mb-4 text-center">
                <div v-if="index == 0">I osiągnięcie</div>
                <div class="-pt-4" v-if="index == 1">II osiągnięcie</div>
                <div class="-pt-4" v-if="index == 2">III osiągnięcie</div>
            </div>
            <div class="row form__gap-24">
                <div class="col-md-12">
                    <p class="form__title text-18 form__pb-8">Rodzaj osiągnięcia<span class="form__label form__label--red"
                            v-if="index == 0">*</span></p>
                    <div :class="{ 'vue-select__error': degreeError(index) }">
                        <vue-select :close-on-select="true" v-model="item.type" :options="inputs.type"
                            placeholder="Rodzaj osiągnięcia" label-by="name" value-by="value"
                            @selected="removeError(index, 'type')">
                            <template #label="{ selected }">
                                <template v-if="selected">
                                    <div>{{ selected.name }}</div>
                                </template>
                            </template>
                        </vue-select>
                    </div>
                    <div class="text-danger" v-if="typeError(index)">
                        {{ typeError(index) }}
                    </div>
                </div>
                <div class="col-md-12">
                    <p class="form__title text-18 form__pb-8">Uzyskany wynik <span class="form__label form__label--red"
                            v-if="index == 0">*</span></p>
                    <div :class="{ 'vue-select__error': degreeError(index) }">
                        <vue-select :close-on-select="true" v-model="item.score" :options="inputs.score"
                            placeholder="Uzyskany wynik" label-by="name" value-by="value"
                            @selected="removeError(index, 'score')">
                            <template #label="{ selected }">
                                <template v-if="selected">
                                    <div>{{ selected.name }}</div>
                                </template>
                            </template>
                        </vue-select>
                    </div>
                    <div class="text-danger" v-if="scoreError(index)">
                        {{ scoreError(index) }}
                    </div>
                </div>
                <div class="col-md-12">
                    <p class="form__title text-18 form__pb-8">Ranga osiągnięcia<span
                            class="form__label form__label--red text-18" v-if="index == 0">*</span></p>
                    <div :class="{ 'vue-select__error': degreeError(index) }">
                        <vue-select :close-on-select="true" v-model="item.degree" :options="inputs.degree"
                            placeholder="Ranga osiągnięcia" label-by="name" value-by="value"
                            @selected="removeError(index, 'degree')">
                            <template #label="{ selected }">
                                <template v-if="selected">
                                    <div>{{ selected.name }}</div>
                                </template>
                            </template>
                        </vue-select>
                    </div>
                    <div class="text-danger" v-if="degreeError(index)">
                        {{ degreeError(index) }}
                    </div>
                </div>
                <div class="col-md-12 text-18">
                    <text-input v-model="item.name" :data="inputs.name" :index="index" />
                </div>
            </div>
        </div>

        <p class="mt-4 color-grey test-12">
            WAŻNE! W przypadku kiedy wynik określają medale (złoty, srebrny, brązowy) nalży wybrać opcję „Miejsca 1-3 lub Laureat (Zwycięzca)”. Z kolei w przypadku kiedy na dyplomie, certyfikacie lub innym dowodzie wzięcia udziału lub wyniku w danej olimpiadzie lub konkursie widnieje opis określający wynik (np. Laureat, Wyróżnienie, Finalista itp.) oraz wskazane zajęte miejsce w olimpiadzie/konkursie, głównym wyznacznikiem oceny jest zajęte miejsce i taką opcję należy wybrać w formularzu. Przykładowo, jeśli na dyplomie jest wskazane, że Uczestnik jest finalistą i zajął miejsce 4, to przypisuje sobie punktację przewidzianą dla miejsca 4. <br>WYJĄTEK: Laureat olimpiady przedmiotowej z przedmiotu lub przedmiotów objętych egzaminem ósmoklasisty albo egzaminem maturalnym w roku szkolnym 2025/2026, ujętej w wykazie ogłoszonym w komunikacie Ministra Edukacji i Nauki, a także Laureat konkursów organizowanych przez kuratorów oświaty, niezależnie od zajętego miejsca, otrzymuje maksymalną liczbę punktów przewidzianą dla olimpiady lub konkursu na danym szczeblu, także powinien zaznaczyć opcję „Miejsca 1-3 lub Laureat (Zwycięzca)”.
        </p>    
        <div class="d-flex justify-content-center -pt-5">
            <button class="button__red " @click="addAchievement" :disabled="form.length > 2 || buttonAchievments">
                <p v-if="form.length < 3">Dodaj kolejne osiągnięcie</p>
                <p v-if="form.length === 3">Dodano maksymalną ilość instytucji</p>
                <img src="@/assets/add-btn.svg" alt="" class="button__arrow" />
            </button>
        </div>
    </div>
</template>

<script>
import VueNextSelect from 'vue-next-select'
import TextInput from "@/components/inputs/TextInput.vue";

export default {
    emits: ['update:modelValue', 'type'],
    props: ['errors', 'modelValue'],
    data() {
        return {
            inputs: {
                name: {
                    type: 'text',
                    title: 'Nazwa osiągnięcia',
                    placeholder: 'Nazwa osiągnięcia',
                    subtitle: null,
                    mandatoryAchievements: '*',
                    model: 'most_achievments_name',
                    stageIndex: 'formStudent.student.most_achievements.stageIndex.name'
                },
                another_degree: {
                    type: 'text',
                    title: 'Określ inną rangę',
                    placeholder: 'Określ inną rangę',
                    subtitle: null,
                    mandatory: '*',
                    model: 'another_degree',
                    stageIndex: 'formStudent.student.most_achievements.stageIndex.degree'
                },
                type: [
                    {
                        name: 'Olimpiada',
                        value: 1
                    },
                    {
                        name: 'Konkurs',
                        value: 2
                    }
                ],
                score: [
                    {
                        name: 'Miejsca 1-3 lub Laureat (Zwycięzca)',
                        value: 1
                    },
                    {
                        name: 'Miejsca lub 4-5 Wynik bardzo dobry',
                        value: 2
                    },
                    {
                        name: 'Miejsca 6-10 lub Wynik dobry (Wyróżnienie)',
                        value: 3
                    },
                    {
                        name: 'Miejsca od 11 lub Finalista',
                        value: 4
                    },
                ],
                degree: [
                    {
                        name: 'Międzynarodowy',
                        value: 1
                    },
                    {
                        name: 'Ogólnopolski/centralny (3 stopień)',
                        value: 2
                    },
                    {
                        name: 'Wojewódzki/regionalny/okręgowy (2 stopień)',
                        value: 3
                    },
                    {
                        name: 'Szkolny/międzyszkolny (1 stopień)',
                        value: 4
                    }
                ],
            },
            form: [
                {
                    name: '',
                    score: null,
                    degree: null,
                    another_degree: '',
                    type: null,
                }
            ]
        }
    },
    components: {
        'vue-select': VueNextSelect,
        TextInput
    },
    computed: {
        buttonAchievments(){
            return this.form.filter((n) => !n.name || n.name == '' || !n.score || n.score == '' || !n.degree || n.degree == '').length;
        }
    },
    watch: {
        form: {
            handler(newVal) {
                this.$emit('update:modelValue', newVal)
                this.updateFormValue('formStudent.student.most_achievements', newVal);
            },
            deep: true
        }
    },
    methods: {
        removeError(index, value) {
            this.$store.commit('removeError', 'student.most_achievements.' + index + '.' + value)
        },
        degreeError(index) {
            const error = this.$store.getters.getError('student.most_achievements.' + index + '.degree');
            if (error && error.length)
                return error[0]

            return null
        },
        scoreError(index) {
            const error = this.$store.getters.getError('student.most_achievements.' + index + '.score');
            if (error && error.length)
                return error[0]

            return null
        },
        typeError(index) {
            const error = this.$store.getters.getError('student.most_achievements.' + index + '.type');
            if (error && error.length)
                return error[0]

            return null
        },
        addAchievement() {
            this.form.push(
                {
                    name: '',
                    score: null,
                    degree: null,
                    another_degree: '',
                    type: null,
                }
            );
        }
    },
};
</script>
